<template>
  <transition name="slide-fade">
    <div class="loader" v-if="show">
      <font-awesome-icon icon="spinner" spin class="icon"/>Loading...
    </div>
  </transition>
</template>

<style lang="scss">

</style>

<script>
export default {
  name: 'Loader',
  data() {
    return {
      show: false,
    };
  },
  methods: {
    showLoader() {
      this.show = true;
    },
    hideLoader() {
      this.timeout = setTimeout(() => {
        this.show = false;
      }, 100);
    },
  },
};
</script>
